module.exports = __webpack_public_path__ + "static/media/RentalHub.9a87ad0d.png";